import { type Specs } from '@doxyme/extensions-bridge';
import { useBasicObservableOptional } from '../useBasicObservable';

type Applet = Specs.Applet.Applet;

/**
 * Subscribe to an applet's content height observable so the host can apply
 * it to a wrapper container rather than letting the bridge set it as an
 * inline style on the iframe.
 */
export function useContentHeight(applet?: Applet): string | null {
  const [height] = useBasicObservableOptional<string | null>(
    null,
    applet?.contentHeight,
  );
  return height;
}
